import { getReq } from '../utils/request'
import { ListResponse, Response } from '../types/api'
import { MunicipalityWasteType, WasteTypeBase, WasteTypeCategory } from '../types/data'

export default {
	loadWasteType: (id: string | number, municipalityID: string | number): Response<WasteTypeBase> => getReq(`/api/v0/municipalities/${municipalityID}/waste-types/${id}`, {}),
	loadWasteTypes: (filters: object = {}): Response<WasteTypeCategory[]> => getReq('/api/v0/waste-types', filters),
	loadMunicipalityWasteTypes: (filters: object = {}): ListResponse<{ wasteTypes: MunicipalityWasteType[] }> => getReq('/api/admin/municipality-waste-types', filters)
}
